var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockFooter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M7,5H9A.5.5,0,0,1,9,6H7A.5.5,0,0,1,7,5ZM3,5H5A.5.5,0,0,1,5,6H3A.5.5,0,0,1,3,5Zm11.5,9H2.5a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h12a2,2,0,0,1,2,2v8A2,2,0,0,1,14.5,14Zm1-10a1,1,0,0,0-1-1H2.5a1,1,0,0,0-1,1V8h14V4Zm0,5H1.5v3a1,1,0,0,0,1,1h12a1,1,0,0,0,1-1Z",
    transform: "translate(-0.5 -2)",
    fill: "#181f38"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockFooter);
export default __webpack_public_path__ + "static/media/block_footer.9bd3a6f118dca59cf6e3d653f79503dd.svg";
export { ForwardRef as ReactComponent };